import { render, staticRenderFns } from "./GTNewsPortalEdit.vue?vue&type=template&id=769b0e52&scoped=true"
import script from "./GTNewsPortalEdit.vue?vue&type=script&lang=js"
export * from "./GTNewsPortalEdit.vue?vue&type=script&lang=js"
import style0 from "./GTNewsPortalEdit.vue?vue&type=style&index=0&id=769b0e52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769b0e52",
  null
  
)

export default component.exports